const contacts = '/contacts';
const companies = `${contacts}/companies`;
const people = `${contacts}/people`;
const tags = `${contacts}/tags`;

export const ROUTES = {
	contacts: {
		main: contacts,
		companies,
		people,
		tags,
	},
	dataBoards: {
		home: '/dataBoards',
		opportunities: '/dataBoards/opportunities',
		donations: '/dataBoards/donations',
		donationsImport: '/dataBoards/donations/import',
		donationsAdvancedReporting: '/dataBoards/donations/advancedReporting',
		policies: '/dataBoards/policies',
		policiesAdvancedReporting: '/dataBoards/policies/advancedReporting',
		contactSelfImport: '/dataBoards/policies/contacts-self-import',
		matters: '/dataBoards/matters',
		mattersImport: '/dataBoards/matters/import',
	},
	reporting: {
		home: '/reporting',
		aiConversations: '/reporting/ai-conversations',
	},
	airesolver: '/airesolver',
} as const;
